<template>
<div style="background-color: #ccc; height: 100%;">

  <img src="../assets/pdf/page1_1.png" alt="" style="width: 100%;">
  <img src="../assets/pdf/page2_1.png" alt="" style="width: 100%;">
</div>
</template>

<script>
export default {
  data() {
    return {

    }
  }
}
</script>

<style lang='less' scoped>

</style>
